<template>
  <div class="c-record">
    <!-- filter -->
    <record-filter
      ref="filter-form"
      :medias="dropMedias"
      :projectData="projectData"
      :syncing="syncing"
      @on-set="setRecordPerson"
      @on-change="filterData"
      @on-search="searchFilterData"
      @get-lock-state="getLockState"
    />
    <div class="c-radio-btn">
      <RadioGroup v-model="recordType" type="button" @on-change="setRecordType">
        <Radio label="account">创角(账号)绩效报表</Radio>
        <Radio label="role">角色绩效报表</Radio>
        <Radio label="device">激活绩效报表</Radio>
      </RadioGroup>

      <div class="row-btns">
        <div class="freeze-data" v-if="authLock">
          <switch-plus v-model="lock" :before-change="lockEvent" />
          <span>冻结数据</span>
        </div>

        <ElButton type="primary" @click="downData">数据导出</ElButton>
        <ElButton :loading="syncing" :disabled="lock" @click="syncData">
          <span v-if="syncing">同步中...</span>
          <span v-else>
            <Icon type="md-sync" size="12" />
            <span>同步数据</span>
          </span>
        </ElButton>
      </div>
    </div>
    <!-- table -->
    <div class="c-table-list" :aaa="tableHeight">
      <Viewport v-model="tableHeight">
        <record-table
          :height="tableHeight"
          :loading="loading"
          :data="tableList"
          :summary="summaries"
          :columns="tableColCustom"
          :type="recordType"
          @on-sort="sortTable"
          @on-refresh="getData"
        />
        <el-pagination
          :total="total"
          :current-page.sync="pageIndex"
          :page-size="pageSize"
          :page-sizes="[10, 20, 30, 40, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          @current-change="changePageIndex"
          @size-change="changePageSize"
          class="c-table-page pager"
          background
        />
      </Viewport>
    </div>
  </div>
</template>
<script>
import mixin from '../mixins/mixin'
import columns from '../data/record_column'
import { setLocal, getLocal, setCookie, getCookie } from '@/common/js/api'
import { isArray, isEmpty } from '@/common/js/utils'
import { HOST_API } from '@/api/config'
import { getSysMember, getSysMedia, getSysProject } from '@/api/common.model'
import {
  syncReportLock,
  getReportLock,
  getGuangzOperator,
  setGuangzOperator,
  getGZRecordList,
  synGZReportKpiList
} from '@/api/manage.model'

import RecordFilter from './components/record-filter'
import RecordTable from './components/record-table'
import SwitchPlus from '@/components/switch-plus'

export default {
  name: 'recordList',
  mixins: [mixin],
  components: { RecordFilter, RecordTable, SwitchPlus },
  computed: {
    authLock() {
      return this.$store.state.accessAuth.includes('M20824')
    },
    tableColCustom() {
      const account = [
        'reportTime',
        'name',
        'gameName',
        'mediaName',
        'amount',
        'thirtyDayKpi',
        'millionRatio',
        'control',
        'createRoleBonus',
        'createRoleBonusDivisor',
        'thirtySynthesizeCreateRoleRetain',
        'thirtySynthesizeCreateRoleMoney'
      ]
      const device = [
        'reportTime',
        'name',
        'gameName',
        'mediaName',
        'amount',
        'thirtyDayKpi',
        'millionRatio',
        'control',
        'activeBonus',
        'activeBonusDivisor',
        'thirtySynthesizeDeviceRetain',
        'thirtySynthesizeDeviceMoney'
      ]
      const role = [
        'reportTime',
        'name',
        'gameName',
        'mediaName',
        'amount',
        'thirtyDayKpi',
        'millionRatio',
        'control',
        'roleBonus',
        'roleBonusDivisor',
        'thirtySynthesizeRetain',
        'thirtySynthesizeMoney'
      ]
      return columns.filter((ret) => {
        if (this.recordType === 'account') return account.includes(ret.key)
        else if (this.recordType === 'device') return device.includes(ret.key)
        else if (this.recordType === 'role') return role.includes(ret.key)
      })
    }
  },
  methods: {
    getLockState(reportMonth) {
      getReportLock({ reportMonth }).then((data) => {
        this.lock = Boolean(data)
      })
    },
    lockEvent() {
      return new Promise((resolve, reject) => {
        const reportMonth = this.$refs['filter-form'].month

        syncReportLock({ reportMonth, lock: Boolean(!this.lock) })
          .then((data) => {
            data && resolve()
          })
          .catch(() => {
            reject(new Error('冻结数据失败！'))
          })
      })
    },
    getData(filter) {
      let params = {
        page_id: this.pageIndex,
        page_size: this.pageSize,
        sort: this.sort,
        order: this.order
      }
      if (filter) params = Object.assign(params, filter)
      else params = Object.assign(this.params, params)
      this.params = JSON.parse(JSON.stringify(params))
      this.loading = true
      getGZRecordList(params)
        .then((data) => {
          this.loading = false
          if (data) {
            const { list, page_info, sum_data } = data
            if (isArray(list) && page_info && sum_data) {
              const { total_number } = page_info
              this.summaries = sum_data
              this.total = total_number || 0
              this.tableList = list.map((ret) => {
                // ret.cpRate = ret.cpRate.toFixed(2)
                return ret
              })
            }
          }
        })
        .catch((err) => {
          this.$Message.error({
            duration: 5,
            content: err
          })
        })
    },
    sortTable(params) {
      const { sort, order } = params
      this.sort = sort
      this.order = order
      // const param = Object.assign(this.params, { sort, order })
      // this.params = JSON.parse(JSON.stringify(param))
      this.pageIndex = 1
      this.getData()
    },
    setLocalPage(size) {
      setLocal('RECORD_PAGESIZE', size)
    },
    setRecordPerson() {
      this.$Spin.show()
      getGuangzOperator().then((data) => {
        this.$Spin.hide()
        if (isArray(data)) {
          this.model = true
          this.operator = data.map((ret) => ret.opId)
        }
      })
    },
    asyncOk() {
      this.saving = true
      setGuangzOperator({
        opIds: this.operator.join(',')
      }).then((data) => {
        this.saving = false
        if (data) {
          this.model = false
          this.getData()
        }
      })
    },
    preLoadData() {
      Promise.all([getSysMedia(), getSysMember(), getSysProject()])
        .then((data) => {
          const [mediaData, agentData, projectData] = data
          if (isArray(mediaData)) {
            this.dropMedias = mediaData.map((ret) => {
              return {
                id: ret.mediaId,
                name: ret.mediaName
              }
            })
          }
          isArray(projectData) && (this.projectData = projectData)
          isArray(agentData) && (this.agentData = agentData)
        })
        .catch((error) => {
          this.$Message.error({
            duration: 5,
            content: error
          })
        })
    },
    downData() {
      let url = `${HOST_API}/api/ptom/guangzKpiData/downMonthReport`
      url += `?sessionid=${this.$store.state.token}&downType=${this.recordType}`
      this.params.reportMonth && (url += `&reportMonth=${this.params.reportMonth}`)
      this.params.opId && (url += `&opId=${this.params.opId}`)
      this.params.gameId && (url += `&gameGroupId=${this.params.gameId}`)
      this.params.mediaId && (url += `&mediaId=${this.params.mediaId}`)
      this.params.gameGroupId && (url += `&gameGroupId=${this.params.gameGroupId}`)
      this.params.projectGroupId && (url += `&projectGroupId=${this.params.projectGroupId}`)
      this.params.order && (url += `&order=${this.params.order}`)
      this.params.sort && (url += `&sort=${this.params.sort}`)
      this.params.gameIdStr && (url += `&gameIdStr=${this.params.gameIdStr}`)
      window.open(url)
    },
    setRecordType(val) {
      setCookie('RECORD_TYPE', val)
    },
    syncData() {
      const params = { reportMonth: this.params.reportMonth }
      this.syncing = true
      synGZReportKpiList(params).then((data) => {
        this.syncing = false
        if (data) {
          this.$Message.success({
            duration: 5,
            content: '数据开始重算，预计需要5~10分钟，请耐心等待.'
          })
          this.getData()
        }
      })
    }
  },
  data() {
    return {
      tableHeight: 330,
      lock: false,
      summaries: {}, // 后台合计对象
      model: false, // 弹窗开关
      saving: false, // 设置状态
      agentData: [], // 所有人员
      operator: [], // 考核人
      dropMedias: [], // 所有媒体
      projectData: [], // 项目组
      recordType: null, // 报表默认
      syncing: false // 同步数据按钮状态
    }
  },
  created() {
    const cookieRecordType = getCookie('RECORD_TYPE')
    this.recordType = isEmpty(cookieRecordType) ? 'account' : cookieRecordType
    this.pageSize = parseInt(getLocal('RECORD_PAGESIZE')) || 20
    this.preLoadData()
  }
}
</script>
<style lang="scss" scoped>
.c-radio-btn {
  margin-top: 0;
  display: flex;
  justify-content: space-between;
  .row-btns {
    display: flex;
    .freeze-data {
      margin-right: 8px;
      display: flex;
      align-items: center;
      font-size: 14px;
    }
  }
}

.c-table-list {
  margin-top: 8px;
}

.c-table-page {
  padding: 8px 0;
  text-align: right;
}
</style>
